import qs from '../../utilities/query-string';
import React, { Component } from 'react';
import WordVerbatimsComponent from "./word-verbatims-component";
import { withRouter } from 'react-router-dom';
import {connect} from "react-redux";
import {changeReportUrl} from "../report/report-action-creators";
import {changePage, loadWordVerbatimsRequest, radioSelect, resetRadio, setWord} from "./word-verbatims-action-creators";
import {setSelectedText, showContextMenu} from "../context-menu/context-menu-action-creators";
import {getSelectedText} from "../context-menu/context-menu-functions";


class WordVerbatimsContainer extends Component {

  constructor(props) {
    super(props);
    const { reportUrl, word } = qs.parse(this.props.location.search);
    this.props.changeReportUrl(reportUrl);
    this.props.setWord(word);
  }

  componentDidMount() {
    const { whoMounted, loadWordVerbatims } = this.props;
    const { word } = qs.parse(this.props.location.search);
    whoMounted !== word ? loadWordVerbatims(word) : null;
  }

  componentWillUnmount() {
    this.props.resetRadio()
  }

  render() {
    return (
      <WordVerbatimsComponent
        {...this.props}
      />
    )
  }
}


const mapStateToProps = state => ({
  reportUrl: state.report.reportUrl,
  word: state.wordVerbatims.word,
  general: state.wordVerbatims.general,
  negation: state.wordVerbatims.negation,
  error: state.wordVerbatims.error,
  loading: state.wordVerbatims.loading,
  radio: state.wordVerbatims.radio,
  selectedRadio: state.wordVerbatims.selectedRadio,
  whoMounted: state.wordVerbatims.whoMounted,
  generalPage: state.wordVerbatims.generalPage,
  negationPage: state.wordVerbatims.negationPage
});

const mapDispatchToProps = dispatch => ({
  changeReportUrl: reportUrl => dispatch(changeReportUrl(reportUrl)),
  setWord: word => dispatch(setWord(word)),
  loadWordVerbatims: word => dispatch(loadWordVerbatimsRequest(word)),
  radioSelect: selectedRadio => dispatch(radioSelect(selectedRadio)),
  changePage: ({ page, general, negation, previous, next }) => dispatch(
    changePage({ page, general, negation, previous, next })
  ),
  resetRadio: () => dispatch(resetRadio()),
  showContextMenu: ({ top, left }) => dispatch(showContextMenu({ top, left })),
  setSelectedText: () => dispatch(setSelectedText(getSelectedText()))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WordVerbatimsContainer));


// WEBPACK FOOTER //
// ./src/modules/word-verbatims/word-verbatims-container.js